import { render, staticRenderFns } from "./discountCategory.vue?vue&type=template&id=5f1c6f20&"
import script from "./discountCategory.vue?vue&type=script&lang=js&"
export * from "./discountCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports